var map = {
	"./certificate_image.png": 1315,
	"./complated.png": 1316,
	"./download_icon.png": 1317,
	"./facebook_icon.png": 678,
	"./linkedin_icon.png": 679,
	"./logo.png": 1318,
	"./pending.png": 1319,
	"./score_icon.png": 1320,
	"./training.png": 1321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1314;